import cookies from 'js-cookie';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { isValidState } from '@repo/supergraph/utils/geo-data';
import { getEntityCount } from '@repo/supergraph/utils/metadata';
import { DEFAULT_STATE_OPTION } from '../../src/GeoTargeting/constants';
import type { HeaderProps } from '../../src/GeoTargeting/GeoHeader';
import { REGION_CODE_COOKIE_NAME } from './constants';

export const getSafeRegionCodeFromClientCookies = (): StateAbbreviation | undefined => {
  const regionCode = cookies.get(REGION_CODE_COOKIE_NAME) ?? '';
  return isValidState(regionCode) ? regionCode : undefined;
};

export const getSafeRegionCode = (state?: string): StateAbbreviation => {
  const regionCode = state ?? DEFAULT_STATE_OPTION;
  return isValidState(regionCode) ? regionCode : DEFAULT_STATE_OPTION;
};

export type MarketplaceEntityWithStates = { marketplaceEntity: { states?: StateAbbreviation[] } };

export const filterEntitiesByState = <T extends MarketplaceEntityWithStates>(
  items: T[],
  state?: StateAbbreviation,
): T[] => {
  if (!items) return [];
  if (!state) return items;
  return items.filter(item => {
    const validStates = item.marketplaceEntity.states;
    return (
      // If validStates is null, undefined, or not an array, include the item
      !Array.isArray(validStates) || validStates.length === 0 || validStates.includes(state)
    );
  });
};

export const overrideGeoTargetedTitle = (titleProps: HeaderProps, state?: StateAbbreviation) => {
  const { title, titleWithoutEntityCount, excludeEntityCountFromTitle, entityCountByLocation } =
    titleProps;
  if (!state) return title;

  let updatedTitle = title;
  if (!excludeEntityCountFromTitle && entityCountByLocation && titleWithoutEntityCount) {
    const numberOfProducts = getEntityCount(entityCountByLocation, state);

    updatedTitle =
      numberOfProducts > 1
        ? `${numberOfProducts} ${titleWithoutEntityCount}`
        : titleWithoutEntityCount;
  }

  return updatedTitle;
};
